"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactSelect = require("react-select");
var _DropdownArrow = _interopRequireDefault(require("../../../icons-react/DropdownArrow"));
var _userflow = _interopRequireDefault(require("../../../styles/userflow"));
var _excluded = ["children"];
var SingleValue = _reactSelect.components.SingleValue;
var CustomSingleValue = function CustomSingleValue(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(SingleValue, props, children, /*#__PURE__*/_react["default"].createElement(StyledDropdownArror, null));
};
var StyledDropdownArror = (0, _styledComponents["default"])(_DropdownArrow["default"]).withConfig({
  displayName: "SingleValue__StyledDropdownArror",
  componentId: "sc-fhbez1-0"
})(["margin-left:4px;stroke:", ";width:12px;height:6px;"], _userflow["default"].colors.blue);
var _default = exports["default"] = CustomSingleValue;